
// const API_BASE_URL = "http://localhost/shreevarma/";  
// const API_BASE_URL = "https://sivakasicrackerscity.com/shreevarma/";
const API_BASE_URL = "https://ayush.shreevarma.org/api/";
export default API_BASE_URL;